import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=573e5a6a&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('573e5a6a')) {
      api.createRecord('573e5a6a', component.options)
    } else {
      api.reload('573e5a6a', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=573e5a6a&", function () {
      api.rerender('573e5a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/roles/Pagination.vue"
export default component.exports